import React, { useState } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined'
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined'
import { Button } from '@workboard/wobo-ui'

import useOnOutsideClick from '../../hooks/use-on-outside-click'

import DatePicker from './date-picker'
import Icon from './icon'

import './ui.scss'

const CalendarIcon = styled(Icon)`
  margin-right: 5px;
  width: 25px;
  fill: ${({ theme }) => theme.palette['--gray']};;
`

const DatePickerTrigger = styled(Button)`
  color: ${({ theme }) => theme.palette['--black-opacity-60']};
  background: transparent;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.palette['--black-opacity-84']};
    background: transparent;
  }
`

const DateRangePicker = ({
  startTime,
  endTime,
  onSelect,
  format = 'ddd, MMM Do',
}) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleToggle = () => {
    setIsVisible(!isVisible)
  }

  const handleSelect = (date) => {
    onSelect(moment(date))
    setIsVisible(false)
  }

  const ref = useOnOutsideClick(() => {
    setIsVisible(false)
  }, isVisible)

  return (
    <div className="m-date-range-picker" ref={ref}>
      <CalendarIcon component={CalendarTodayOutlinedIcon} />

      <DatePickerTrigger
        endIcon={<KeyboardArrowDownOutlinedIcon />}
        onClick={handleToggle}
      >
        {startTime.format(format)}
        { endTime &&
          <> - {endTime.format(format)}</> }
      </DatePickerTrigger>

      { isVisible &&
        <DatePicker
          date={startTime}
          onChange={handleSelect}
        /> }
    </div>
  )
}

export default DateRangePicker
